var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: 1300,
            "footer-hide": true,
            title: "生成发货单",
            scrollable: true,
          },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "Form",
                        {
                          staticClass: "form-input-no-outline",
                          attrs: { "label-position": "top" },
                        },
                        [
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "订单号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.billCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "苗场" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.seedFarmName,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateTimeString(
                                            _vm.orderRecord
                                              .depositBillRecordCreateAt
                                          ),
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "周期" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.weekSeq,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "发货时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateString(
                                            _vm.orderRecord
                                              .depositBillRecordSendProductDate
                                          ),
                                        },
                                        model: {
                                          value: _vm.sendDeliveryDate,
                                          callback: function ($$v) {
                                            _vm.sendDeliveryDate = $$v
                                          },
                                          expression: "sendDeliveryDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "支付状态" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.paidStatus,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单总额(元)" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord.totalMoneyActual,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "待付金额(元)" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord.paidStatus ==
                                            "全额支付"
                                              ? 0
                                              : _vm.orderRecord.remainingSum,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "5" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "省份",
                                        prop: "depositBillRecordProvince",
                                      },
                                    },
                                    [
                                      _c(
                                        "Select",
                                        {
                                          attrs: {
                                            filterable: "",
                                            clearable: "",
                                            placeholder: "请选择省",
                                          },
                                          on: {
                                            "on-change": _vm.onProvinceChange,
                                          },
                                          model: {
                                            value:
                                              _vm.orderRecord
                                                .depositBillRecordProvince,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.orderRecord,
                                                "depositBillRecordProvince",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "orderRecord.depositBillRecordProvince",
                                          },
                                        },
                                        _vm._l(
                                          _vm.provinceOptions,
                                          function (item) {
                                            return _c(
                                              "Option",
                                              {
                                                key: item.regionUuid,
                                                attrs: {
                                                  value: item.regionUuid,
                                                },
                                              },
                                              [_vm._v(_vm._s(item.regionName))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "5" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "城市",
                                        prop: "depositBillRecordCity",
                                      },
                                    },
                                    [
                                      _c(
                                        "Select",
                                        {
                                          attrs: {
                                            filterable: "",
                                            clearable: "",
                                            placeholder: "请选择市",
                                          },
                                          on: { "on-change": _vm.onCityChange },
                                          model: {
                                            value:
                                              _vm.orderRecord
                                                .depositBillRecordCity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.orderRecord,
                                                "depositBillRecordCity",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "orderRecord.depositBillRecordCity",
                                          },
                                        },
                                        _vm._l(
                                          _vm.cityOptions,
                                          function (item) {
                                            return _c(
                                              "Option",
                                              {
                                                key: item.regionUuid,
                                                attrs: {
                                                  value: item.regionUuid,
                                                },
                                              },
                                              [_vm._v(_vm._s(item.regionName))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "5" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "区/县",
                                        prop: "depositBillRecordDist",
                                      },
                                    },
                                    [
                                      _c(
                                        "Select",
                                        {
                                          attrs: {
                                            filterable: "",
                                            clearable: "",
                                            placeholder: "请选择区/县",
                                          },
                                          model: {
                                            value:
                                              _vm.orderRecord
                                                .depositBillRecordDist,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.orderRecord,
                                                "depositBillRecordDist",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "orderRecord.depositBillRecordDist",
                                          },
                                        },
                                        _vm._l(
                                          _vm.distOptions,
                                          function (item) {
                                            return _c(
                                              "Option",
                                              {
                                                key: item.regionUuid,
                                                attrs: {
                                                  value: item.regionUuid,
                                                },
                                              },
                                              [_vm._v(_vm._s(item.regionName))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "9" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "客户地址" } },
                                    [
                                      _c("Input", {
                                        model: {
                                          value:
                                            _vm.orderRecord.receiptFullAddress,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.orderRecord,
                                              "receiptFullAddress",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "orderRecord.receiptFullAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "关联销售单号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "10" } },
                                [
                                  _vm.$checkAccessArray(["B", "C"])
                                    ? _c(
                                        "FormItem",
                                        { attrs: { label: "苗场备注" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              placeholder:
                                                "提醒:点击保存按扭可保存苗场备注!",
                                              type: "textarea",
                                            },
                                            model: {
                                              value: _vm.orderRecord.remark,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.orderRecord,
                                                  "remark",
                                                  $$v
                                                )
                                              },
                                              expression: "orderRecord.remark",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.$checkAccessArray(["S", "G"])
                                    ? _c(
                                        "FormItem",
                                        { attrs: { label: "苗场备注" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value: _vm.orderRecord.remark,
                                              readonly: "",
                                              type: "textarea",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "8" } },
                                [
                                  _vm.$checkAccessArray(["S", "B"])
                                    ? _c(
                                        "FormItem",
                                        { attrs: { label: "客户备注" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value:
                                                _vm.orderRecord.customerMsg,
                                              readonly: "",
                                              type: "textarea",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "6" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "佣金比例" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .depositBillDetailSalesAssociateCommissionPercent,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "其它优惠" } },
                                    [
                                      _c("InputNumber", {
                                        attrs: {
                                          value:
                                            _vm.depositBillDetailsArtiDiscUnitDisAmount,
                                          precision: 4,
                                          step: 0.0001,
                                          min: 0,
                                          formatter: (value) =>
                                            parseFloat(value.toString()),
                                          "active-change": false,
                                        },
                                        on: {
                                          "on-change": function ($event) {
                                            return _vm.changeArtiDiscUnitDisAmount(
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "FormItem",
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_c("b", [_vm._v("定金单明细")])]
                                      ),
                                      _c("Table", {
                                        ref: "mainTable",
                                        attrs: {
                                          size: "small",
                                          columns: _vm.orderDetail.columns,
                                          data: _vm.orderDetail.rows,
                                          stripe: "",
                                          border: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "FormItem",
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_c("b", [_vm._v("发货单明细")])]
                                      ),
                                      _c("Table", {
                                        ref: "mainTable",
                                        attrs: {
                                          size: "small",
                                          columns: _vm.preOrderDetail.columns,
                                          data: _vm.preOrderDetail.rows,
                                          stripe: "",
                                          border: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "right" } },
                [
                  _vm.isCanBeforehand
                    ? _c(
                        "Button",
                        {
                          staticStyle: { "margin-right": "20px" },
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.earlyTerminationDeposit()
                            },
                          },
                        },
                        [_vm._v("提前结束发货")]
                      )
                    : _vm._e(),
                  _c(
                    "Button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "info" },
                      on: {
                        click: function ($event) {
                          return _vm.generatePreSaleDelivery(0)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "Button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.generatePreSaleDelivery(1)
                        },
                      },
                    },
                    [_vm._v("保存并提交")]
                  ),
                  _c(
                    "Button",
                    {
                      attrs: { type: "error" },
                      on: {
                        click: function ($event) {
                          _vm.show = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("payModalDetail", { ref: "PayModal" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }